// https://github.com/NewOldMax/react-material-ui-form-validator
import React, { useEffect, useState} from 'react';
import { Stack, Switch, Autocomplete, Grid, Paper, Container, Card, CardContent, TextField, FormControl, FormLabel, FormControlLabel, FormHelperText, RadioGroup, Radio, Button, Box, Dialog, DialogTitle, DialogContent } from '@mui/material';
import Close from '@mui/icons-material/Close';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import moment from 'moment';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import CircularProgress from '@mui/material/CircularProgress';

const ResStructureElement = ({ f }) => {
  if(f.ueberschrift){
    return (
      <>
        <Box width="100%"/>
        <Grid item xs={12} sm={12} lg={12} key={"grid"+f.id_freiesfeld}>
          <h3>
            {f.ueberschrift}
          </h3>
        </Grid>
      </>
    )
  }
  if(f.abstandvor){
    return <Box width="100%" height="1.5em" />
  }
}

const getOptDisabled = (option) => {
  if(option.disabled)return true
  return false
}

const getLabel = (option) => {
  if (typeof option === 'object') return option.text;
  if (!option) return '';
  return option;
}

const RadioList = ({source, tip, value, onChange, options, label}) => {
  return (
    <FormControl>
      <FormLabel id={"rbgr"+source}>{label}</FormLabel>
      <RadioGroup
        aria-labelledby={"rbgr"+source}
        name={"crbg"+source}
        value={value}
        onChange={onChange}
      >
      { options && options.map((f)=>(
        <FormControlLabel value={f.id} control={<Radio />} label={f.text} disabled={f.disabled} />
      ))}
      </RadioGroup>
      <FormHelperText>{tip}</FormHelperText>
    </FormControl>
  )
}

const FlexInput = ({source, typ, funktion, disabled, tip, updateField, updateSelect, updateDate, updateBool, ...rest}) => {
  /*
    0:Textfeld
    1:Datum
    2:Auswahl
    2-7:Auswahl und Eingabe
    3:Mehrzeilig,
    4:JaNeinFeld
    5:Zwischentitel
    6:Radio Buttons
  */
  if (typ===0 || typ==='Text') {
    return (<TextField {...rest} helperText={tip} onChange={(ev)=>updateField(ev)} disabled={disabled} />);
  }
  else if (typ===1 || typ==='Termin') {
    return (<DatePicker {...rest} renderInput={(props) => <TextField {...props} style={{marginTop:'16px'}} fullWidth />} value={moment(rest.value)} onChange={(ev)=>{updateDate(ev, source)}} disabled={disabled} />);
  }
  else if (typ===2 || typ==='Auswahl') {
    if (funktion===7)
      return (<Autocomplete {...rest} 
        onChange={(ev, val)=>updateSelect(val, source)} 
        blurOnSelect freeSolo={true} disabled={disabled} 
        renderInput={(params) => <TextField id={source} {...params} label={rest.label} helperText={tip} />} 
        getOptionLabel={getLabel}
        getOptionDisabled={getOptDisabled}
        />);
    else 
      return (<Autocomplete {...rest}
        onChange={(ev, val)=>updateSelect(val, source)} 
        blurOnSelect disabled={disabled} 
        renderInput={(params) => <TextField id={source} {...params} label={rest.label} helperText={tip} />} 
        getOptionLabel={getLabel}
        getOptionDisabled={getOptDisabled}
        />);
  }
  else if (typ===3 || typ==='Mehrzeilig') {
    return (<TextField {...rest} helperText={tip} onChange={(ev)=>updateField(ev)} multiline disabled={disabled} />);
  }
  else if (typ===4) {
    return (<FormControlLabel {...rest} control={<Switch name={rest.name} checked={!!rest.value} onChange={updateBool} disabled={disabled} inputProps={{ 'aria-label': 'controlled' }} />} />);
  }
  else if (typ===5) {
    return (<h3>{rest.label}</h3>);
  }
  else if (typ===6 || typ==='Ausw. Tab.') {
    return (<RadioList {...rest} source={source} onChange={(ev, val)=>updateSelect({id:val}, source)} disabled={disabled} 
      renderInput={(params) => <TextField id={source} {...params} label={rest.label} helperText={tip} />} 
    />);
  }
}


const AlixonEvent = ({ev='', is_test, apihost, ...props}) => {
  const [eventKey, setEventKey] = useState(ev);
  const [event, setEvent] = useState({});
  const [values, setValues] = useState({});
  const [msg, setMsg] = useState("");
  const [updating, setUpdating] = useState(false);
  const [saved, setSaved] = useState(false);

           
  require('moment/locale/de');
  moment.locale('de');
  
  const getChoices = (opts) => {
    if (typeof opts === 'object') return opts;
    var options = []
    if(opts){
      opts.split(';').forEach((c)=>{
        options.push({id:c, text:c});
      })
    }
    return options
  }
  
  const updateData = () => {
    var fdata = new FormData();
    var errFelder = []
    for(let key in event.fields){
      if(event.fields[key].pflicht === 1){
        if(!values['frei_'+event.fields[key].id_freiesfeld]){
          errFelder.push(event.fields[key].feldname)
        }
      }
    }
    for(let key in event.res){
      if(event.res[key].pflicht === 1){
        if(values['rval_'+event.res[key].ressource_id] === "" || values['rval_'+event.res[key].ressource_id] === false){
          errFelder.push(event.res[key].feldbez)
        }
      }
    }
    if(errFelder.length > 0){
      setMsg("Folgende Felder können nicht leer sein: "+errFelder.join(", "))
      return
    }
    for(let key in values) {
      if(key.startsWith('rval_')){
        fdata.append( key, values[key] );
      }
      if(key.startsWith('frei_')){
        fdata.append( key, values[key] );
      }
    }
    setUpdating(true);
    fetch("https://"+apihost+"eveRegister/"+eventKey+"/1",
    {
        method: "POST",
        body: fdata
    })
    .then((res) => res.json())
    .then((rdata) => {
      if(rdata.error){
        setUpdating(false);
        setMsg(rdata.error);
      }
      setSaved(true);
      if (event.allowchange) {
        getEventData();
        setUpdating(false);
      }
      else {
        if(rdata.newKey){
          setEventKey(rdata.newKey);
          window.location = '/res/?e='+rdata.newKey;
        }
        else if(rdata.ok){
          window.location = '/res/?e='+eventKey;
        }
      }
    })   
  };

  function getEventData() {
    fetch("https://"+apihost+"eveRegister/"+eventKey+"/1",
    {
        method: "GET",
    })
    .then((res) => res.json())
    .then((rdata) => {
      setEvent(rdata);
      const values = {};
      for(let key in rdata) {
        if(key.startsWith('rval_') || key.startsWith('frei_')) {
          values[key] = rdata[key];
        }
      }
      setValues(values);
    })   
  }

  useEffect(() => {
    getEventData();
  }, []);
  const error = {}

  const updateBool = (e) => {
    setValues({...values, [e.target.name]:(e.target.checked?true:false)});
  }

  const updateDate = (e, src) => {
    setValues({...values, [src]:(e.format('YYYY-MM-DD'))});
  }

  const updateSelect = (val, src) => {
    setValues({...values, [src]:val.id});
  }
  
  const updateField = (e) => {
    setValues({...values, [e.target.name]:e.target.value});
  }
  const ETMap = {Text:0, Mehrzeilig: 3, Kontrollkästchen: 4, Auswahl: 2, 'Ausw. Tab.':6, Anzahl: 0, Termin: 1};

  if (event.error) {
    return ( <Paper style={{margin:'1em'}}><Card><CardContent><h1>{event.error}</h1></CardContent></Card></Paper>);
  }
  if (event.anmeldeschluss!=='0000-00-00' && moment(event.anmeldeschluss).isBefore(moment())) {
    return <Paper style={{margin:'1em'}}><Card><CardContent><h1>Eventaneldung für &laquo;{event.eventname}&raquo; ist abgelaufen</h1></CardContent></Card></Paper>
  }
  return (
  <LocalizationProvider dateAdapter={AdapterMoment}>
    <Dialog onClose={()=>{setMsg("")}} open={msg!==""} maxWidth="md" >
      <Close onClick={()=>{setMsg("")}} sx={{ position:'absolute', right:'8px', top:'8px', cursor:'pointer'}} />
      <DialogTitle>Achtung</DialogTitle>
      <DialogContent>
        {msg}
      </DialogContent>
    </Dialog>
    <Container maxWidth="lg" >
      <Paper style={{margin:'1em'}}>
        <Card>
          <CardContent>
            <div style={{paddingLeft:1+'em'}} key="EvHead">
              <h1>Anmeldung für den Event: {event.eventname}</h1>
              <p>Datum: {moment(event.datum).format('DD.MM.YYYY')}</p>
            </div>
    {saved && <div style={{ paddingLeft:1+'em', paddingTop:'1em' }}><h2>Die Anmeldung wurde gespeichert</h2></div>}
    {event['aid']>0 && !event['allowchange'] ?
              <div style={{ paddingLeft:1+'em', paddingTop:'1em' }}>
                {event.feedback 
                  ? <div dangerouslySetInnerHTML={{ __html: event.feedback }} style={{ backgroundColor: "#eee", padding: "1em", borderRadius: "0.3em"}} />
                  : <h2>Sie sind Angemeldet</h2>}
              </div>
    : 
      <>
            <div style={{ paddingLeft:1+'em', paddingTop:'1em' }} key="persDatHead" >
              <h2>Personendaten:</h2>
            </div>
            <Grid container spacing={2}>
            { event.fields && event.fields.map((f)=>(
              <Grid item xs={12} sm={6} lg={3} key={"grid"+f.id_freiesfeld}>
                <Stack>
                  <FlexInput 
                    value = {values["frei_"+f.id_freiesfeld]?values["frei_"+f.id_freiesfeld]:''}
                    name={"frei_"+f.id_freiesfeld} 
                    label={f.feldname} 
                    source={"frei_"+f.id_freiesfeld} 
                    typ={f.typ} 
                    funktion={f.funktion} 
                    options={getChoices(f.optionen)} 
                    disabled={f.erfassen===0 && event["frei_"+f.id_freiesfeld] && event["pid"]>0 || updating || saved} 
                    tip={f.tip} 
                    required={f.pflicht===1} 
                    updateField={updateField}
                    updateDate={updateDate}
                    updateSelect={updateSelect}                    
                    updateBool={updateBool}                    
                  />
                </Stack>
              </Grid>
            ))}
      {updating && <Grid item xs={12}><div style={{textAlign:'center', margin:'1em'}}><CircularProgress size={80} /></div></Grid>}
      {!updating && <>
                <Grid item xs={12}>
                  <h2>Eventdaten:</h2>
                </Grid>
                { event && event.res && event.res.map((f)=>(
                  <React.Fragment key={f.ressource_id} >
                    <ResStructureElement f={f} />
                    <Grid item xs={12} sm={f.ganzezeile===1?12:6} lg={f.ganzezeile===1?12:3} key={"res"+f.ressource_id}>
                      <Stack>
                        <FlexInput 
                          value={values["rval_" + f.ressource_id] ?? ''}
                          name={"rval_" + f.ressource_id} 
                          label={f.feldbez} 
                          source={"rval_" + f.ressource_id} 
                          typ={ETMap[f.typ]} funktion={0} 
                          options={getChoices(f.optionen)} 
                          disabled={f.disabled || saved} 
                          required={f.pflicht===1} 
                          fullWidth={f.ganzezeile===1?1:undefined} 
                          updateField={updateField}
                          updateDate={updateDate}
                          updateSelect={updateSelect}                    
                          updateBool={updateBool}                    
                        />
                      </Stack>
                    </Grid>
                  </React.Fragment>
                ))}
        {!saved &&
                  <Grid item xs={12}>
                    <Button variant="contained" color="primary" onClick={updateData} sx={{ mt:'1em'}}>
                      Anmeldung abschicken
                    </Button>
                </Grid>
        }
      </>}
            </Grid>
    </>
    }
          </CardContent>
        </Card>
      </Paper>
    </Container>
  </LocalizationProvider>
  )
}

export default AlixonEvent;
